module.exports = __webpack_public_path__ + "img/close.0aef02eb.svg";